import { render, staticRenderFns } from "./ProfileMisDirecciones.vue?vue&type=template&id=a38fa706&"
import script from "./ProfileMisDirecciones.vue?vue&type=script&lang=js&"
export * from "./ProfileMisDirecciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports